/** Live iyafglobal.com photos bundled from backup/extracted-photos. */
const base = `${process.env.PUBLIC_URL || ""}/assets/legacy`;

export const legacyImages = {
  logo: `${base}/site/logo-sm.png`,
  logoFull: `${base}/site/logo.png`,
  trad: `${base}/team/president.jpeg`,
  ameer: `${base}/team/ameer.jpg`,
  favicon: `${base}/../logos/iyaf-mark.png`,
  about1: `${base}/site/about-company-1.jpg`,
  about2: `${base}/site/about-company-2.jpg`,
  about3: `${base}/site/about-company-3.jpg`,
  heroHeader: `${base}/hero/TJ2022-header.jpg`,
  heroEvent: `${base}/hero/DSC0180.jpg`,
  services: `${base}/site/services.jpg`,
  ctaBg: `${base}/site/cta-bg.jpg`,
  storyHub: `${base}/stories/hub-event.jpg`,
  storyYouth: `${base}/stories/youth-program.jpg`,
  storyWorkshop: `${base}/stories/workshop.jpg`,
};
